import React from "react";
import "./About.css";
import "../Experience/Experience.css";
const About = () => {
  const [More, setMore] = React.useState(false);
  const [More2, setMore2] = React.useState(false);
  const [More3, setMore3] = React.useState(false);
  const personal = `I am Karim Darrag. A passionate and motivated Data Analyst, Microsoft Certified: Power BI Data Analyst Associate, and Computer Science graduate. My professional
work experience includes several data-related software programming projects as well as using industry leading BI tools to manage, analyze, and
visualize data, draw conclusions, and apply data-driven decision making. My curiosity greatly fuels my passion to learn many different skills that I can
apply to tackle new challenges and provide efficient solutions.`;
  const education = `I am a Computer Science graduate from the Lassonde School
          of Engineering at York University (BSc). I was born in Cairo, Egypt,
          and I left to go to Canada while I was in elementary school. I stayed
          in Canada until middle school, where I went back to Egypt and stayed
          until the end of high school. Afterwards, I left to go back to Canada
          to study Computer Science at York University at the age of 18 and
          graduated at the age of 22.`;
  const goal = `To better the world as much as I can.`;
  return (
    <>
      <section className="about">
        <a href="./Karim Darrag Resume.pdf" download>
          <button className="hero__button2">
            Download Resume <i class="fa fa-arrow-down"></i>
          </button>{" "}
        </a>
      </section>
      <section className="about">
        <p>
          <h1>
            Education&nbsp;
            <span style={{ color: "indianred" }}>
              <i class=" 	fa fa-graduation-cap"></i>
            </span>
          </h1>
          {education}
        </p>

        <p>
          <h1>
            Personal Life&nbsp;
            <span style={{ color: "indianred" }}>&#9835;</span>
          </h1>
          {personal}
        </p>

        <p>
          <h1>
            Goal&nbsp;<span style={{ color: "indianred" }}>&#10004;</span>
          </h1>
          {goal}
        </p>
      </section>
    </>
  );
};

export default About;
